import { render, staticRenderFns } from "./new_list.vue?vue&type=template&id=7deea960&scoped=true&"
import script from "./new_list.vue?vue&type=script&lang=js&"
export * from "./new_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deea960",
  null
  
)

export default component.exports